import { ExportTableDialog, TableSettingsDialog } from "@/ds";
import { ListaToolbar } from "@/shared/components/lista-toolbar";
import { EmbarcacaoDetailDialog } from "./components/embarcacao-detail-dialog";
import { EmbarcacoesTabela } from "./components/embarcacoes-tabela";
import {
  EMBARCACOES_EXPORT_LIST_NAME,
  EMBARCACOES_SEARCH_PLACEHOLDER,
  EMBARCACOES_SEARCH_PLACEHOLDER_MOBILE,
  EMBARCACOES_TITLE,
} from "./embarcacoes.constants";
import styles from "./embarcacoes.module.scss";
import type { EmbarcacoesScreenViewModel } from "./types-embarcacoes";

/** Listagem de Embarcações (HU 812): consulta somente leitura; a lupa ou a linha abre o detalhamento. */
export function EmbarcacoesScreenView({
  isMobile,
  search,
  buscar,
  filterColumns,
  filters,
  applyFilters,
  filtrosSalvos,
  settings,
  exportView,
  notifySettingsApplied,
  tabela,
  detalhe,
  fecharDetalhe,
  reautenticar,
}: EmbarcacoesScreenViewModel) {
  return (
    <section className={styles.container} data-full-bleed data-testid="embarcacoes-screen">
      <header className={styles.header}>
        <h1 className={styles.title}>{EMBARCACOES_TITLE}</h1>
      </header>

      <ListaToolbar
        testIdPrefix="embarcacoes"
        isMobile={isMobile}
        search={search}
        onSearchChange={buscar}
        searchPlaceholder={
          isMobile ? EMBARCACOES_SEARCH_PLACEHOLDER_MOBILE : EMBARCACOES_SEARCH_PLACEHOLDER
        }
        wideSearch
        inlineActions
        filterDefinitions={filterColumns}
        filterValue={filters}
        onFilterChange={applyFilters}
        {...filtrosSalvos}
        onExport={exportView.open}
        onOpenSettings={settings.dialog.open}
      />

      {exportView.isOpen ? (
        <ExportTableDialog
          listName={EMBARCACOES_EXPORT_LIST_NAME}
          isExporting={exportView.isExporting}
          onExport={exportView.run}
          onCancel={exportView.close}
        />
      ) : null}

      <TableSettingsDialog
        dialog={settings.dialog}
        testId="embarcacoes-table-settings"
        onApplied={notifySettingsApplied}
      />

      {/* A listagem permanece montada por trás do modal. */}
      {detalhe !== null ? (
        <EmbarcacaoDetailDialog
          embarcacaoId={detalhe.id}
          identity={detalhe}
          onClose={fecharDetalhe}
          onReauthenticate={reautenticar}
        />
      ) : null}

      <div className={styles.content}>
        <EmbarcacoesTabela {...tabela} />
      </div>
    </section>
  );
}
